import { CommonModule } from '@angular/common';
import { Component, computed, OnInit, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { AuthService } from '../../../core/services/auth.service';
import { WebViewService } from '../../../core/services/webview.service';
import { NavigationService } from '../../../core/services/navigation.service';
import { LogoutComponent } from '../logout/logout.component';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { PqrsAmplitudeService } from '../../../core/services/pqrs-amplitude.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatDialogModule,
    TranslatePipe
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit {
  public canGoBack = computed(() => this.navigationService.canGoBack());
  public showUserMenu = signal(false);
  public isAuthenticated = computed(() => this.authService.isAuthenticated());
  public currentUser = computed(() => this.authService.currentUser());

  constructor(
    private authService: AuthService,
    private webviewService: WebViewService,
    private navigationService: NavigationService,
    private dialog: MatDialog,
    private pqrsAmplitudeService: PqrsAmplitudeService
  ) {}

  ngOnInit(): void {}

  goBack(): void {
    this.navigationService.goBack();
  }

  changePassword(): void {
    this.navigationService.goToChangePassword();
  }

  logout(): void {
    const dialogRef = this.dialog.open(LogoutComponent, {
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      maxHeight: '100%',
      disableClose: false,
      panelClass: 'app-container-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Capturar el usuario actual antes del logout para enviar el evento con el ID correcto
        const currentUser = this.currentUser();
        this.pqrsAmplitudeService.sendUserLogOut({}, currentUser?.id);
        this.webviewService.logout();
      }
    });
  }

  getPageTitle(): string {
    return this.navigationService.getPageTitle();
  }

  createRequest(): void {
    this.navigationService.goToCreate();
  }
}
